import classnames from 'classnames';
import ReactMarkdown from 'react-markdown';
import type { VoidFunctionComponent } from 'react';

import styles from './Markdown.module.less';

type Props = {
  /**
   * The raw markdown text.
   */
  text: string;
  /**
   * Additional class name for styling.
   */
  className?: string;
};

/**
 * A react-markdown wrapper with custom styling.
 */
const Markdown: VoidFunctionComponent<Props> = ({ text, className }) => {
  const allClassNames = classnames(styles.markdown, className ?? '');

  return (
    <div className={allClassNames}>
      <ReactMarkdown>
        {text}
      </ReactMarkdown>
    </div>
  );
};

export default Markdown;
